// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"7150ae16","623":"f654506b","649":"6114e2a6","890":"4b342f02","911":"bc797257"}[chunkId] + ".chunk.css";
};